import {Feat,RawMango,Injiri,PranoySarkar, Marriott,Islasridge,CM} from "../../images";
const projects = [
    {
      title: "Feat Artists",
      url: "https://feat-artists.com/",
      description:"Agency Website",
      color: "#E95800",
      img: Feat
    },{
      title: "Others by Raw Mango",
      url: "https://jatinkukreja18.github.io/RawMangoCampaign/",
      description:"Campaign Page",
      color: "#E95800",
      img: RawMango
    },{
      title: "I N J I R I",
      url: "https://www.injiri.co.in",
      description:"Fashion Brand Website",
      color: "#E95800",
      img: Injiri
    },
    {
      title: "Pranoy Sarkar",
      url: "https://www.pranoysarkar.com",
      description:"Photographer Portfolio Website",
      color: "#1099A8",
      img: PranoySarkar
    },
    {
      title: "ClubMarriott x HDFC",
      url: "https://jatinkukreja18.github.io/ClubMarriott/",
      description:"Landing Page",
      color: "#BC027F",
      img: Marriott
    },
    {
      title: "ClubMarriott Website",
      url: "https://www.clubmarriott.in/",
      description:"Website",
      color: "#0D96F2",
      img: CM
    },
    {
      title: "Isla's Ridge",
      url: "https://islasridge.com/",
      description:"Landing Page ",
      color: "#8EB814",
      img: Islasridge
    },
  ]
export default projects;